import { useEffect, useRef } from "react";
import {
  ActivityIndicator,
  Animated,
  Easing,
  Platform,
  SafeAreaView,
  StatusBar,
  StyleSheet,
  View,
} from "react-native";
import { CreateThemeOptions, Text, ThemeProvider } from "react-native-elements";
import {
  initialWindowMetrics,
  SafeAreaProvider,
} from "react-native-safe-area-context";
import { OrientationLockManager } from "../utils/OrientationLockManager";

export function Loading(props: { theme: CreateThemeOptions | undefined }) {
  const theme = props.theme;

  const loadingAnim = useRef(new Animated.Value(0.0)).current;

  useEffect(() => {
    Animated.timing(loadingAnim, {
      useNativeDriver: true,
      toValue: 400,
      duration: 40000,
      easing: Easing.out(Easing.poly(5)),
    }).start();
  }, []);

  return (
    <SafeAreaProvider initialMetrics={initialWindowMetrics}>
      <ThemeProvider theme={theme}>
        <OrientationLockManager />
        <StatusBar
          translucent={true}
          backgroundColor="transparent"
          barStyle={theme?.mode === "dark" ? "light-content" : "dark-content"}
        />
        <SafeAreaView
          style={[
            styles.safeAreaContainer,
            {
              backgroundColor:
                theme?.mode === "dark"
                  ? theme?.darkColors?.background
                  : theme?.lightColors?.background,
            },
          ]}
        >
          <View style={{ alignItems: "center", width: "100%" }}>
            <ActivityIndicator size="large" />
            {Platform.OS != "web" && (
              <View
                style={{
                  width: 200,
                  marginVertical: 8,
                  borderWidth: 1,
                  borderRadius: 3,
                  height: 6,
                  overflow: "hidden",
                  borderColor:
                    theme?.mode === "dark"
                      ? theme?.darkColors?.primary
                      : theme?.lightColors?.primary,
                }}
              >
                <Animated.View
                  style={{
                    height: 4,
                    width: 1,
                    transform: [{ scaleX: loadingAnim }],
                    backgroundColor:
                      theme?.mode === "dark"
                        ? theme?.darkColors?.primary
                        : theme?.lightColors?.primary,
                  }}
                />
              </View>
            )}

            <Text
              style={{
                color:
                  theme?.mode === "dark"
                    ? theme?.darkColors?.black
                    : theme?.lightColors?.black,
              }}
            >
              Loading game. Please wait a moment...
            </Text>
          </View>
        </SafeAreaView>
      </ThemeProvider>
    </SafeAreaProvider>
  );
}

const styles = StyleSheet.create({
  safeAreaContainer: {
    flex: 1,
    justifyContent: "center",
  },
});
